import { ADDRESS_CONSTS } from 'helpers/sf_constants';
import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'reactstrap';
import BaseComponent from './BaseComponent';

const AddressAutoFillComponent = ({ index, question, onChangeEvent }) => {
  const [inputValue, setInputValue] = useState(question?.value || ''); // Track input value in state
  const inputRef = useRef(null);
  const autoCompleteRef = useRef(null);
  const options = {
    componentRestrictions: { country: "us" },
    fields: [
      "address_components",
      "adr_address",
      "formatted_address",
      "geometry",
      "icon",
      "name",
      "photos",
      "place_id",
      "reference",
      "types",
      "url",
      "utc_offset",
      "website"
    ],
    types: ["route", "administrative_area_level_1", "locality"]
  };

  useEffect(() => {
    if (inputRef.current) {
      // Initialize Autocomplete when inputRef is available
      autoCompleteRef.current = new window.google.maps.places.Autocomplete(
        inputRef.current,
        options
      );

      autoCompleteRef.current.addListener("place_changed", async function () {
        const place = await autoCompleteRef.current.getPlace();
        const addressComponents = place.address_components;

        // Initialize variables to store the data
        let fields = {
          address: place.name,
          fill_type: ADDRESS_CONSTS.AUTO
        };

        // Iterate through address components to find the required information
        addressComponents.forEach((component) => {
          if (component.types.includes("postal_code")) {
            fields.zip = component.short_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            fields.state = component.short_name;
          } else if (component.types.includes("locality")) {
            fields.city = component.long_name;
          }
        });
        onChangeEvent(JSON.stringify(fields));
        setInputValue(place.name)
      });
    }
  }, []);

  useEffect(() => {
    if (question?.value) {
      setInputValue(question?.value)
    }
  }, [question?.value])

  // Handle input value changes
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (question?.placeholder === 'Address') {
      const trimmedValue = value?.replace(/\s+/g, ' ');
      if (trimmedValue.trim() !== '') {
        setInputValue(trimmedValue);
        let fields = {
          address: trimmedValue,
          fill_type: ADDRESS_CONSTS.MANUAL
        };
        onChangeEvent(JSON.stringify(fields));
      }
      else {
        setInputValue('');
      }
    }
  };

  return (
    <BaseComponent question={question}>
      <Row key={index} className='d-flex justify-content-around align-items-center'>
        <Col className='mb-2'>
          <input
            ref={inputRef}
            id={question?.id || ''}
            className='quote-funnel-form-control form-control'
            value={inputValue}
            autoFocus={true}
            placeholder={question?.placeholder}
            onChange={handleInputChange}
          />
        </Col>
      </Row>
    </BaseComponent>
  );
}

export default AddressAutoFillComponent;
